(function($) {

	function updateMaxHeight() {
		var maxHeight = 0;
		$('.home-blog .tools .items .item').each(function(index, el) {
			$(el).height();
			if ( maxHeight < $(el).height() ) maxHeight = $(el).height();
		});

		$('.home-blog .tools .items .item').each(function(index, el) {
			$(el).height( maxHeight );
		});

		maxHeight = 0;
		var maxWidth = 0;
		$('.ratings-carousel img').each(function(index, el) {
			$(el).height('');
			if ( maxHeight < $(el).height() ) maxHeight = $(el).height();
			if ( maxWidth < $(el).width() ) maxWidth = $(el).width();
		});

		$('.ratings-carousel').height( maxHeight ).width( maxWidth );
	}
	var imgs = $('.home-blog .tools .items img, .ratings-carousel img'),
		len = $('.home-blog .tools .items img').length,
		counter = 0;

	imgs.each(function(index, el) {
		$(el).load(function() {
			incrementCounter();
		});
	});

	function incrementCounter() {
		counter++;
		if ( counter >= len ) {
			$('.home-blog .tools .items .item').css('height','auto');
	    	updateMaxHeight();
		}
	}

	function esrbUpdatePushers() {
		$('.home-blog .item .excerpt').each(function(index, el) {
			var height = $(el).height();
			var pusher = $(el).find('.pusher');
			pusher.height(height - 75);
		});
	}

	// add SquarePusher to items
	esrbUpdatePushers();
	$(window).on('resize', function(){
		esrbUpdatePushers();
		$('.home-blog .tools .items .item').css('height','auto');
		updateMaxHeight();
	});

	$('.home-blog .tools .items').on('init breakpoint', function(event, slick, currentSlide, nextSlide) {
		esrbUpdatePushers();
		$('.home-blog .tools .items .item').css('height','auto');
		updateMaxHeight();
	});

	$('.home-blog .tools .items').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: $('.home-blog .nav .prev'),
		nextArrow: $('.home-blog .nav .next'),
		responsive: [
			{ breakpoint: 2500 },
			{ breakpoint: 2160 },
			{ breakpoint: 1860 },
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1
				}
 			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$.fn.randomize = function(childElem) {
		return this.each(function() {
			var $this = $(this);
			var elems = $this.children(childElem);

			elems.sort(function() { return (Math.round(Math.random())-0.5); });  

			$this.detach(childElem);  

			for(var i=0; i < elems.length; i++)
				$this.append(elems[i]);      

		});    
	}
	$("div.slider").randomize("div.slider-slide");

	$('.home-did-you-know .slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
        adaptiveHeight: true,
		prevArrow: $('.home-did-you-know .nav .prev'),
		nextArrow: $('.home-did-you-know .nav .next')
	});

	var ratingSlides = $('.ratings-carousel img');
	ratingSlides.eq(0).addClass('on');
	var currentRatingSlide = 0,
		nextRatingSlide;

	var ratingDots = $('<div class="dots"></div>');
	ratingSlides.each(function(index, el) {
		ratingDots.append('<i class="dot" data-slide="'+index+'" tabindex="0" aria-label="slide number ' + ( index + 1 ) +'"></i>');
	});
	$('.ratings-carousel').append(ratingDots);
	ratingDots.find('.dot').eq(0).addClass('on');

	function flipRatingSlide( newSlide ) {
		if(newSlide === currentRatingSlide){
			return;
		}
		nextRatingSlide = newSlide;

		ratingSlides.eq(currentRatingSlide).addClass('out');
		ratingSlides.eq(nextRatingSlide).addClass('in');

		setTimeout( function() {
			ratingSlides.eq(nextRatingSlide).addClass('on').removeClass('in');
			ratingSlides.eq(currentRatingSlide).removeClass('on out');
			ratingDots.find('.dot').removeClass('on').eq(nextRatingSlide).addClass('on');
			currentRatingSlide = nextRatingSlide;
		}, 100 );
	}

	function flipNextSlide () {
		if ( currentRatingSlide + 1 < ratingSlides.length ) {
			nextRatingSlide = currentRatingSlide + 1;
		} else {
			nextRatingSlide = 0;
		}

		flipRatingSlide( nextRatingSlide );
	}

	var timerRatingSlider = setInterval( flipNextSlide, 3500);

	ratingDots.on('click', '.dot', function(event) {
		event.preventDefault();
		clearInterval( timerRatingSlider );
		flipRatingSlide( parseInt($(this).attr('data-slide')) );
		timerRatingSlider = setInterval( flipNextSlide, 3500);
	});

	$('.home-hero .down').on('click', function(event) {
		event.preventDefault();
		
		var headerHeight = $('.site-header .header-content').height();

		var $hero = $(this).closest('.home-hero');
		var heroTop = $hero.offset().top;
		var heroHeight = $hero.height();

		var contentOffset = heroTop + heroHeight - headerHeight;

		$('html, body').stop().animate({scrollTop: contentOffset}, 500, 'swing');
	});

	function crop_game_names() {

		if($('.search-ratings .games').length){

			var width_ul = $('.search-ratings .games').width() - 20;
			$('.search-ratings .games li a').each(function(){
				var width_a = $(this).width();

				if(width_a > width_ul ){

					var num_letters = $(this).text().length;
					var average_letter_width = width_ul / num_letters;
					var num_letters_visible = width_a / average_letter_width;
					num_letters_visible = num_letters_visible.toFixed() - 4;
					var new_a = $(this).text().substr(0,num_letters_visible) + '...';
					$(this).text(new_a);
				}
			});

		}
	}
	if($(document).width()>767){
		crop_game_names();
	}

	$(window).resize(function(){
		if($(document).width()>767){
			crop_game_names();
		}
	});


})(jQuery);